import React from "react";
import { Stack,} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import {Gauge} from "@mui/x-charts";
import Card from "@mui/joy/Card";


const getColor = (value, min, max) => {
    if (value - min < (max-min) * 0.5) return '#4CAF50';
    if (value - min < (max-min) * 0.8) return '#FF9800';
    return '#F44336';
};


class MLHostGpu extends React.Component {
    render() {
        return(
            <Card
                sx={{
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: '49%',
                        lg: '49%',
                    }
                }}
            >
                <Stack
                    spacing={2}
                    sx={{
                        width: '100%'
                    }}
                >
                    <Typography
                        level={'title-lg'}
                    >
                        GPU: {this.props.gpu.name} :: {this.props.gpu.uuid}
                    </Typography>

                    <Stack
                        direction={'row'}
                        spacing={1}
                        useFlexGap
                        sx={{ flexWrap: 'wrap' }}
                    >
                        <Card
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '49%',
                                    lg: '49%',
                                }
                            }}
                        >
                            <Typography
                                level={'title-md'}
                            >
                                VRAM (max {this.props.gpu.memory_total})
                            </Typography>
                            <Gauge
                                skipAnimation={true}
                                width={120}
                                height={120}
                                value={this.props.gpu.memory_used}
                                valueMin={0}
                                valueMax={this.props.gpu.memory_total}
                                startAngle={-90}
                                endAngle={90}
                                valueFormat={(v) => `${v}`}
                                sx={{
                                    '& .MuiGauge-valueText': {fontSize: '1rem', fontWeight: 600},
                                    '& .MuiGauge-valueArc': {
                                        stroke: getColor(this.props.gpu.memory_used, 0, this.props.gpu.memory_total),
                                        fill: getColor(this.props.gpu.memory_used, 0, this.props.gpu.memory_total),
                                    }
                                }}
                            />
                        </Card>
                        <Card
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '49%',
                                    lg: '49%',
                                }
                            }}
                        >
                            <Typography
                                level={'title-md'}
                            >
                                Температура
                            </Typography>
                            <Gauge
                                skipAnimation={true}
                                width={120}
                                height={120}
                                value={this.props.gpu.temperature_gpu}
                                valueMin={20}
                                valueMax={90}
                                startAngle={-90}
                                endAngle={90}
                                valueFormat={(v) => `${v}`}
                                sx={{
                                    '& .MuiGauge-valueText': {fontSize: '1rem', fontWeight: 600},
                                    '& .MuiGauge-valueArc': {
                                        stroke: getColor(this.props.gpu.temperature_gpu, 20, 90),
                                        fill: getColor(this.props.gpu.temperature_gpu, 20, 90),
                                    }
                                }}
                            />
                        </Card>
                        <Card
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '49%',
                                    lg: '49%',
                                }
                            }}
                        >
                            <Typography
                                level={'title-md'}
                            >
                                Нагрузка
                            </Typography>
                            <Gauge
                                skipAnimation={true}
                                width={120}
                                height={120}
                                value={this.props.gpu.utilization_gpu}
                                valueMin={0}
                                valueMax={100}
                                startAngle={-90}
                                endAngle={90}
                                valueFormat={(v) => `${v}`}
                                sx={{
                                    '& .MuiGauge-valueText': {fontSize: '1rem', fontWeight: 600},
                                    '& .MuiGauge-valueArc': {
                                        stroke: getColor(this.props.gpu.utilization_gpu, 0, 100),
                                        fill: getColor(this.props.gpu.utilization_gpu, 0, 100),
                                    }
                                }}
                            />
                        </Card>
                        <Card
                            sx={{
                                width: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '49%',
                                    lg: '49%',
                                }
                            }}
                        >
                            <Typography
                                level={'title-md'}
                            >
                                Потребляемая мощность
                            </Typography>
                            <Gauge
                                skipAnimation={true}
                                width={120}
                                height={120}
                                value={this.props.gpu.power_draw}
                                valueMin={0}
                                valueMax={this.props.gpu.power_limit}
                                startAngle={-90}
                                endAngle={90}
                                valueFormat={(v) => `${v}`}
                                sx={{
                                    '& .MuiGauge-valueText': {fontSize: '1rem', fontWeight: 600},
                                    '& .MuiGauge-valueArc': {
                                        stroke: getColor(this.props.gpu.power_draw, 0, this.props.gpu.power_limit),
                                        fill: getColor(this.props.gpu.power_draw, 0, this.props.gpu.power_limit),
                                    }
                                }}
                            />
                        </Card>

                    </Stack>
                </Stack>
            </Card>

        )
    }
}

export default MLHostGpu;
